(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-switcher"] && !Shopify.designMode) return;
  try {
    // Shopify Official Localization Form Handler
  // Based on Shopify documentation: https://shopify.dev/docs/themes/architecture/locales/locale-aware-urls
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.select = this.querySelector('.localization-select');
      this.hiddenInput = this.querySelector('input[name="language_code"][type="hidden"]');
      
      if (!this.form || !this.select) return;
      
      this.init();
    }
    
    init() {
      // Handle select change
      this.select.addEventListener('change', this.onSelectChange.bind(this));
      
      // Protect form from AJAX interception
      this.form.addEventListener('submit', this.onFormSubmit.bind(this), true);
    }
    
    onSelectChange(event) {
      const selectedValue = event.target.value;
      
      // Don't submit if value hasn't changed
      if (this.hiddenInput && this.hiddenInput.value === selectedValue) {
        return;
      }
      
      // Update hidden input value
      if (this.hiddenInput) {
        this.hiddenInput.value = selectedValue;
      }
      
      // Add loading state
      this.select.disabled = true;
      this.select.style.opacity = '0.7';
      this.select.style.cursor = 'wait';
      
      // Ensure form method is POST
      this.form.method = 'post';
      
      // Ensure form action is set correctly (Shopify form tag should set this, but ensure it)
      if (!this.form.action || this.form.action.trim() === '') {
        this.form.action = '/localization';
      }
      
      // Prevent any AJAX interception by removing data attributes that might trigger it
      this.form.removeAttribute('data-remote');
      this.form.removeAttribute('data-type');
      
      // Submit form natively - this should work in production
      // In local dev, if 502 occurs, it's likely a server configuration issue
      setTimeout(() => {
        this.form.submit();
      }, 10);
    }
    
    onFormSubmit(event) {
      // Protect from AJAX interception
      // Stop other handlers from converting to AJAX/GET
      event.stopImmediatePropagation();
      event.stopPropagation();
      
      // Ensure POST method
      if (this.form.method.toLowerCase() !== 'post') {
        this.form.method = 'post';
      }
      
      // Remove any attributes that might trigger AJAX
      this.form.removeAttribute('data-remote');
      this.form.removeAttribute('data-type');
      this.form.removeAttribute('data-confirm');
      
      // Allow default POST submission - don't preventDefault
      // The form should submit natively
    }
  }
  
  // Register custom element
  customElements.define('localization-form', LocalizationForm);
  
  // Fallback for browsers without custom element support
  document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('form[action*="/localization"]');
    
    forms.forEach(form => {
      const select = form.querySelector('select[name="language_code"]');
      const hiddenInput = form.querySelector('input[name="language_code"][type="hidden"]');
      
      if (select && hiddenInput) {
        // Remove any AJAX-triggering attributes
        form.removeAttribute('data-remote');
        form.removeAttribute('data-type');
        
        select.addEventListener('change', function() {
          hiddenInput.value = this.value;
          form.method = 'post';
          
          // Ensure form action is set
          if (!form.action || form.action.trim() === '') {
            form.action = '/localization';
          }
          
          // Protect from interception
          form.addEventListener('submit', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            if (form.method.toLowerCase() !== 'post') {
              form.method = 'post';
            }
          }, true);
          
          // Small delay to ensure all handlers are set
          setTimeout(() => {
            form.submit();
          }, 10);
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
